import _ from "lodash";
import React from "react";
import { Modal, Button, Alert } from "@toddle-edu/ds-web";
import { useI18n } from "Hooks";
import { updateChannel } from "MessagingV2/modules/MessagingModule";
import { getFormattedNameForUserType } from "MessagingV2/modules/Utils";
import { connect } from "react-redux";
import classes from "./RemoveUserConfirmationModal.scss";

// This Modal is Deprecated
const RemoveUserConfirmationModal = props => {
  const {
    onCloseModal,
    handleRemoveUser,
    user,
    channelLabel,
    isButtonDisabled,
  } = props;

  const { t } = useI18n(["common"]);

  const userName = !_.isEmpty(user)
    ? getFormattedNameForUserType({ user })
    : "";

  return (
    <Modal
      isOpen={true}
      width="480px"
      height="fit-content"
      onClose={onCloseModal}
    >
      <Modal.Header
        title={t("common:remove_name_label_confirmation", {
          name: userName,
          label: channelLabel,
        })}
      />
      <Modal.Body>
        <div className={classes.modalBodyContainer}>
          <Alert
            type={"warning"}
            showIcon={true}
            title={t(
              "common:name_removed_from_channel_msg_has_access_to_messages",
              {
                name: userName,
              }
            )}
          />
        </div>
      </Modal.Body>
      <Modal.Footer>
        <div className={classes.footerContainer}>
          <Button variant="outlined-subtle" size="large" onClick={onCloseModal}>
            {t("common:discard")}
          </Button>
          <Button
            variant="primary"
            size="large"
            onClick={handleRemoveUser}
            disabled={isButtonDisabled}
          >
            {t("common:remove")}
          </Button>
        </div>
      </Modal.Footer>
    </Modal>
  );
};

const mapActionCreator = {
  updateChannel,
};

export default connect(null, mapActionCreator)(RemoveUserConfirmationModal);
